import * as tslib_1 from "tslib";
import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import createItem from 'owa-mail-store/lib/services/createItem';
import createResponseFromModernGroup from 'owa-mail-store/lib/services/createResponseFromModernGroupItem';
import postGroupItem from 'owa-mail-store/lib/services/postGroupItem';
import createItemIdForRequest from './createItemIdForRequest';
import getErrorMessageFromResponseCode from './getErrorMessageFromResponseCode';
import getRecipientsFromWellViewState from './getRecipientsFromWellViewState';
import getDataUriCount from './getDataUriCount';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import message from 'owa-service/lib/factory/message';
import removeSrcAttributeFromInlineImages from './removeSrcAttributeFromInlineImages';
import replyAllToItem from 'owa-service/lib/factory/replyAllToItem';
import replyToItem from 'owa-service/lib/factory/replyToItem';
import sendOrSaveMessageService from 'owa-mail-store/lib/services/sendOrSaveMessageService';
import setFromInfoToMessage from './setFromInfoToMessage';
import updateComposeItemId from '../actions/updateComposeItemId';
import updateInternetMessageId from '../actions/updateInternetMessageId';
import addInfoBarMessage from '../actions/addInfoBarMessage';
import { format } from 'owa-strings';
import { preHandleErrorResponse } from './wasclUtils';
import { findComposePlugins } from '../plugins/ComposePlugins';
import getDetailErrorInfobarHandler from './getDetailErrorInfobarHandler';
var HTML_WRAPPER = '<html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
    '<style type="text/css" style="display:none;"> P {{margin-top:0;margin-bottom:0;}} </style>' +
    '</head><body dir="{0}">{1}</body></html>';
var LTR = 'ltr';
var RTL = 'rtl';
function loadAtMentionsData(viewState, isSend, message) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var plugins, plugin, _a, userSession, mentionWrappers, pendingTags, pickerPlugin, _b, dataProvider, userSession, mentionWrappers, pendingTags;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    plugins = findComposePlugins(viewState);
                    if (!(plugins &&
                        ((plugins.atMentionsPlugin && plugins.atMentionsPlugin.isImported()) ||
                            (plugins.editorPickerPlugin && plugins.editorPickerPlugin.isImported())))) return [3 /*break*/, 8];
                    if (!plugins.atMentionsPlugin) return [3 /*break*/, 2];
                    return [4 /*yield*/, plugins.atMentionsPlugin.getPlugin()];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = null;
                    _c.label = 3;
                case 3:
                    plugin = _a;
                    if (!plugin) return [3 /*break*/, 4];
                    if (isSend) {
                        userSession = getUserConfiguration().SessionSettings;
                        mentionWrappers = plugin.getMentionsWrappersForSend({
                            MailboxType: 'Mailbox',
                            RoutingType: 'SMTP',
                            EmailAddress: userSession.UserEmailAddress,
                            Name: userSession.UserDisplayName,
                        });
                        if (mentionWrappers && mentionWrappers.length > 0) {
                            message.MentionsEx = mentionWrappers;
                        }
                    }
                    else {
                        pendingTags = plugin.getPendingTagsForSave();
                        if (pendingTags.length > 0) {
                            message.PendingSocialActivityTagIds = pendingTags;
                        }
                    }
                    return [3 /*break*/, 8];
                case 4:
                    if (!plugins.editorPickerPlugin) return [3 /*break*/, 6];
                    return [4 /*yield*/, plugins.editorPickerPlugin.getPlugin()];
                case 5:
                    _b = _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _b = null;
                    _c.label = 7;
                case 7:
                    pickerPlugin = _b;
                    if (pickerPlugin) {
                        dataProvider = pickerPlugin.dataProvider;
                        if (isSend) {
                            userSession = getUserConfiguration().SessionSettings;
                            mentionWrappers = dataProvider.getMentionsWrappersForSend({
                                MailboxType: 'Mailbox',
                                RoutingType: 'SMTP',
                                EmailAddress: userSession.UserEmailAddress,
                                Name: userSession.UserDisplayName,
                            });
                            if (mentionWrappers && mentionWrappers.length > 0) {
                                message.MentionsEx = mentionWrappers;
                            }
                        }
                        else {
                            pendingTags = dataProvider.getPendingTagsForSave();
                            if (pendingTags.length > 0) {
                                message.PendingSocialActivityTagIds = pendingTags;
                            }
                        }
                    }
                    _c.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
function getMessageForRequest(viewState) {
    var bodyValue = viewState.content;
    if (viewState.bodyType == 'HTML') {
        var isRtl = getUserConfiguration().SessionSettings.IsUserCultureRightToLeft;
        bodyValue = removeSrcAttributeFromInlineImages(bodyValue);
        bodyValue = format(HTML_WRAPPER, isRtl ? RTL : LTR, bodyValue);
    }
    var body = bodyContentType({ BodyType: viewState.bodyType, Value: bodyValue });
    body.DataUriCount = getDataUriCount(viewState.content);
    var itemId = createItemIdForRequest(viewState.itemId);
    var referenceItemId = createItemIdForRequest(viewState.referenceItemId);
    var toRecipients = getRecipientsFromWellViewState(viewState.toRecipientWell);
    var ccRecipients = getRecipientsFromWellViewState(viewState.ccRecipientWell);
    var bccRecipients = getRecipientsFromWellViewState(viewState.bccRecipientWell);
    var messageType;
    if (viewState.useSmartResponse) {
        // If the current compose form uses smart response, we always send the CreateItem request for both send and save
        // since there is not quoted body in inline compose, we could only set NewBodyContent,
        // Server side will find out the quoate body and create this item.
        var createMessageType = viewState.operation == 2 /* ReplyAll */ ? replyAllToItem : replyToItem;
        messageType = createMessageType({
            Subject: viewState.subject,
            UpdateResponseItemId: itemId,
            ReferenceItemId: referenceItemId,
            ReferenceItemDocumentId: viewState.referenceItemDocumentId || 0,
            ToRecipients: toRecipients,
            CcRecipients: ccRecipients,
            BccRecipients: bccRecipients,
            NewBodyContent: body,
            Importance: viewState.importance,
        });
    }
    else {
        // If the current compose form is full compose and the compose is newly opened, there is no itemId for it
        // We use CreateItem to create this new item.
        // When the response is back from the server, the itemId will be set.
        // Next time to send or save in full compose, we could use sendOrSaveMessageService to update item.
        messageType = message({
            Body: body,
            Subject: viewState.subject || '',
            ToRecipients: toRecipients,
            CcRecipients: ccRecipients,
            BccRecipients: bccRecipients,
            Importance: viewState.importance,
        });
        if (viewState.itemId) {
            messageType.ItemId = viewState.itemId;
        }
    }
    if (viewState.fromViewState) {
        setFromInfoToMessage(viewState.fromViewState, messageType);
    }
    return messageType;
}
function sendOrSaveMessage(viewState, isSend) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var message, timeFormat, response, responseMessage, error;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    message = getMessageForRequest(viewState);
                    return [4 /*yield*/, loadAtMentionsData(viewState, isSend, message)];
                case 1:
                    _a.sent();
                    timeFormat = getUserConfiguration().UserOptions.TimeFormat;
                    return [4 /*yield*/, selectAndExecuteSendOrSaveApi(viewState, message, timeFormat, isSend)];
                case 2:
                    response = _a.sent();
                    responseMessage = response && response.ResponseMessages && response.ResponseMessages.Items
                        ? response.ResponseMessages.Items[0]
                        : null;
                    if (responseMessage && responseMessage.ResponseClass == 'Success') {
                        return [2 /*return*/, Promise.resolve(responseMessage)];
                    }
                    else {
                        preHandleErrorResponse(response, viewState);
                        error = void 0;
                        if (responseMessage) {
                            error = new Error(responseMessage.ResponseCode);
                            error.messageText = responseMessage.MessageText;
                        }
                        else {
                            error = new Error('Unrecognized response');
                        }
                        return [2 /*return*/, Promise.reject(error)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function selectAndExecuteSendOrSaveApi(viewState, message, timeFormat, isSend) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groupComposeViewState, isReply, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    groupComposeViewState = viewState;
                    if (!(groupComposeViewState.groupId && viewStateHasGroupRecipient(groupComposeViewState))) return [3 /*break*/, 4];
                    if (!(isSend && viewState.operation != 3 /* Forward */)) return [3 /*break*/, 2];
                    return [4 /*yield*/, postGroupItem(groupComposeViewState.groupId, message, viewState.bodyType, timeFormat, viewState.isInlineCompose)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    isReply = viewState.operation == 1 /* Reply */ ||
                        viewState.operation == 2 /* ReplyAll */;
                    if (!((!viewState.itemId && isReply) || viewState.useSmartResponse)) return [3 /*break*/, 4];
                    return [4 /*yield*/, createResponseFromModernGroup(message, viewState.bodyType, false /* isSend */, timeFormat, viewState.isInlineCompose)];
                case 3: return [2 /*return*/, _b.sent()];
                case 4:
                    if (!(viewState.useSmartResponse || !viewState.itemId)) return [3 /*break*/, 6];
                    return [4 /*yield*/, createItem(message, viewState.bodyType, isSend, timeFormat, viewState.isInlineCompose, viewState.IRMData)];
                case 5:
                    _a = _b.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, sendOrSaveMessageService(message, isSend, viewState.IRMData)];
                case 7:
                    _a = _b.sent();
                    _b.label = 8;
                case 8: return [2 /*return*/, _a];
            }
        });
    });
}
export function sendMessage(viewState) {
    return sendOrSaveMessage(viewState, true /*isSend*/);
}
export function saveMessage(viewState) {
    return sendOrSaveMessage(viewState, false /*isSend*/);
}
export function handleSuccessResponse(responseMessage, viewState) {
    // VSO 16297: responseMessage.Items is null when the request contains attachment
    // Workaround it here to check null before we use it. We can remove this check or this comment once we figure out why Items can be null
    if (responseMessage && responseMessage.Items) {
        var message_1 = responseMessage.Items[0];
        if (message_1) {
            if (message_1.ItemId) {
                updateComposeItemId(viewState, message_1.ItemId.Id, message_1.ItemId.ChangeKey, message_1.LastModifiedTime);
            }
            if (message_1.InternetMessageId) {
                updateInternetMessageId(viewState.conversationId, viewState.itemId ? viewState.itemId.Id : null, message_1.InternetMessageId);
            }
        }
    }
}
/* Group may have been removed from recipients since creating a group compose view state. In that
case we don't want to use post group item and should send a regular email instead. Check to see if
the view state still contains  the group as a recipient */
function viewStateHasGroupRecipient(groupComposeViewState) {
    return groupComposeViewState.toRecipientWell.recipients.some(function (recipient) {
        return (recipient.persona.EmailAddress.EmailAddress.toLowerCase() ===
            groupComposeViewState.groupId.toLowerCase());
    });
}
export function handleErrorResponse(error, viewState, isSend) {
    var messageId = getErrorMessageFromResponseCode(error ? error.message : null, isSend);
    if (messageId == 'errorMessageMessageCanNotBeSent' && error.messageText) {
        // Add detailed message text to common send failure error infobar
        addInfoBarMessage(viewState, 'errorMessageErrorWithDetail', getDetailErrorInfobarHandler(error.messageText));
    }
    else {
        addInfoBarMessage(viewState, messageId);
    }
}
//# sourceMappingURL=sendSaveUtils.js.map